import { useAuthState } from '../../services/auth';
import { useContext, useEffect, useState } from 'react'
import axios from 'axios';

//import useBreadcrumbs from "use-react-router-breadcrumbs";
import { useNavigate } from 'react-router-dom';
import { Table, Pagination, Collapse, Row, Col, Modal, Button, Form, Navbar, Container, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const appNames = ['dde', 'mongo' , 'mqtt' , 'redis'];
//const appNames = ['DDE'];

export const Dnsquery = () => {
  //const user: User = useUserState();
  const {token} = useAuthState();
  const [currentPage, setCurrentPage] = useState(1);
  const [dnsQueries, setDnsQueries] = useState<any[]>([])
  const [totalCount, setTotalCount] = useState<any>(1)
  const [pageSize, setPageSize] = useState<any>(1)
  const [serviceStatus, setServiceStatus] = useState<any>()
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const [showCreateForm, setShowCreateForm] = useState(false);

  const handleShowCreateForm = () => {
    setShowCreateForm(true);
  };

  const handleCloseCreateForm = () => {
    setShowCreateForm(false);
  };

  useEffect(() => {
    if (token) {
        fetchDnsQueries();
      //fetchServiceStatus();
    }
  }, [token, currentPage]);


  async function fetchDnsQueries() {
    const data = await axios.get('/op/dns/get_all_query?page='+currentPage+'&pageSize=10');
    setTotalCount(data.data.totalCount);
    setPageSize(data.data.pageSize);
    setDnsQueries(data.data.items);
    console.log('aqui', data.data.items)
  }

  const totalPages = Math.ceil(totalCount / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
 
  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };



  const getPageItems = () => {
    const pageItems = [];
    const maxPageItems = 5;
    const maxPageItemsDelta = Math.floor(maxPageItems / 2);
    const startPage = Math.max(currentPage - maxPageItemsDelta, 1);
    const endPage = Math.min(currentPage + maxPageItemsDelta, totalPages);

    if (startPage > 1) {
      pageItems.push(
        <Pagination.Ellipsis key="start-ellipsis" disabled />
      );
    }

    for (let pageNumber = startPage; pageNumber <= endPage; pageNumber++) {
      const isCurrentPage = pageNumber === currentPage;
      pageItems.push(
        <Pagination.Item
          key={pageNumber}
          active={isCurrentPage}
          onClick={() => handlePageChange(pageNumber)}
        >
          {pageNumber}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      pageItems.push(
        <Pagination.Ellipsis key="end-ellipsis" disabled />
      );
    }

    return pageItems;
  };

  const handleShowEditModal = (index: any) => {
    setSelectedItem(dnsQueries[index]);
    setSelectedIndex(index);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setSelectedItem(null);
    setSelectedIndex(-1);
    setShowEditModal(false);
  };

  const handleEditSubmit = async (e: any) => {
    e.preventDefault();
    try{
        await axios.put(`/op/dns/dns-query/${dnsQueries[selectedIndex].id}`, {
            description: e.target.description.value,
            result: e.target.result.value === 'allow',
            profile: e.target.profile.value,
            requester: 0,
            name: e.target.name.value,
        });
        fetchDnsQueries();
        handleCloseEditModal();
    } catch(err) {
        console.log(err)
    }
  };

  const handleShowDeleteModal = (index:any) => {
    setSelectedItem(dnsQueries[index]);
    setSelectedIndex(index);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setSelectedItem(null);
    setSelectedIndex(-1);
    setShowDeleteModal(false);
  };

  const handleDeleteConfirm = async () => {
    try{
        await axios.delete(`/op/dns/dns-query/${dnsQueries[selectedIndex].id}`);
        handleCloseDeleteModal();
        fetchDnsQueries();
    } catch(err) {
        console.log(err)
    }
  };

  const handleCreateSubmit = async (e: any) => {
    e.preventDefault();
    try{
        await axios.post(`/op/dns/dns-query`, {
            description: e.target.description.value,
            result: e.target.result.value === 'allow',
            profile: e.target.profile.value,
            requester: 0,
            name: e.target.name.value,
        });
        handleCloseCreateForm();
        fetchDnsQueries();
    } catch(err) {
        console.log(err)
    }



  };
  return (
    
    <>
      {!showCreateForm && (
            <div className="text-right">
                <Button variant="success" size="sm" onClick={handleShowCreateForm}>Create</Button>
            </div>
        )}

        {showCreateForm && (
            <>
                <Form id="createForm" onSubmit={handleCreateSubmit}>
                    <Form.Control type="text" name="description" placeholder="Description" required />

                    <Form.Control className="mt-1"  as="select" name="result">
                    <option value="allow">Allow</option>
                    <option value="block">Block</option>
                    </Form.Control>

                    <Form.Control className="mt-1"  as="select" name="profile">
                    <option value="">No Profile</option>
                    <option value="68hj1h1q70">Under12</option>
                    <option value="68h8xtxhb1">Early Teen</option>
                    <option value="68dskdxof1">Young Adults</option>
                    </Form.Control>

                    <Form.Control className="mt-1"  type="text" name="name" placeholder="Name" required  />
                </Form>

                <Button form="createForm" variant="primary" size="sm" type="submit">Create</Button>{' '}
                <Button variant="secondary" size="sm" onClick={handleCloseCreateForm}>Cancel</Button>

                </>
        )}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Description</th>
            <th>Result</th>
            <th>Profile</th>
            <th>Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {dnsQueries.map((item, index) => (
            <tr key={index}>
              <td>{item.description}</td>
              <td>{item.result ? 'Allow' : 'Block'}</td>
              <td>{item.profile}</td>

              <td>{item.name}</td>
              <td>
                <Button className="me-2"  variant="primary" onClick={() => handleShowEditModal(index)}>Edit</Button>
                <Button variant="danger" onClick={() => handleShowDeleteModal(index)}>Delete</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination>
            <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
            />
            <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
            />
            {getPageItems()}
            <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            />
            <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
            />
            </Pagination>

      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
            <Form.Group controlId="description">
              <Form.Label>Description</Form.Label>
              <Form.Control type="text" defaultValue={selectedItem?.description} />
            </Form.Group>
            <Form.Group controlId="result">
              <Form.Label>Result</Form.Label>
              <Form.Control as="select" defaultValue={selectedItem?.result ? 'allow' : 'block'}>
                <option value="allow">Allow</option>
                <option value="block">Block</option>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="profile">
              <Form.Label>Profile</Form.Label>
              <Form.Control type="text" defaultValue={selectedItem?.profile} />
            </Form.Group>
            <Form.Group controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" defaultValue={selectedItem?.name} />
            </Form.Group>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete "{selectedItem?.description}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>Cancel</Button>
          <Button variant="danger" onClick={handleDeleteConfirm}>Confirm</Button>
        </Modal.Footer>
      </Modal>
      </>
  )
}
